export enum CommunicationCategory {
  PROFILE_SHARE = 1,
  PROVIDER_ONBOARDING_REMINDER = 2,
  CREDENTIAL_FILE_EXPIRATION_REMINDER = 3,
  CHAT_NOTIFICATION = 4,
  JOB_POST_NOTIFICATION = 5,
  JOB_POST_INTEREST = 6,
  TRANSACTIONAL = 7,
  ACCOUNT_SIGNUP_REMINDER = 8,
  /** @deprecated Merged into JOB_OFFER_NOTIFICATION. Retained for existing
   * preference rows; not emitted and hidden from settings. Do not reuse. */
  JOB_OFFER_REMINDER = 9,
  TIME_ENTRY_REMINDER = 10,
  // Org-side categories — keep numerically separate from provider-side so a
  // user with both personas can opt out of one without affecting the other.
  ORG_CHAT_NOTIFICATION = 11,
  ORG_JOB_POST_INTEREST = 12,
  JOB_OFFER_NOTIFICATION = 13,
  ORG_JOB_OFFER_NOTIFICATION = 14,
  // 15 was org_job_offer_rejected (0214_manual.sql) but 0215_manual.sql merged it
  // into 14 and deleted the row, so 15 is free again.
  HIRING_PROCESS_PENDING_REMINDER = 15,
  ORG_COMPLIANCE_DIGEST = 16,
  ORG_TIMESHEET_SUBMISSION = 17,
  ORG_PSV_MONITORING_DIGEST = 18,
}
